import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function NotFound() {
  return (
    <div className="max-w-md mx-auto px-4 py-24 text-center">
      <h1 className="font-heading font-black text-6xl text-[#1a3a5c] mb-2">404</h1>
      <p className="text-muted-foreground mb-6">La página que buscas no existe.</p>
      <Link to="/"><Button className="bg-[#c8860a] hover:bg-[#c8860a]/90 rounded-full">Volver al Inicio</Button></Link>
    </div>
  );
}
